<template>
  <header>
    <img src="./../assets/images/asset5_header.png" />
  </header>
</template>

<script>
export default {};
</script>


// WEBPACK FOOTER //
// src/components/Header.vue